import { Divider, List, Typography } from '@mui/material';
import MoreOptionsIconButton from 'modules/common/components/buttons/moreOptionsIconButton';
import MoreOptionsItem from 'modules/common/components/moreOptionsItem';
import { ShortcutGroupAction, ShortcutGroupToShortcuts } from 'modules/shortcuts/models';
import React from 'react';

interface IMoreShortcutGroupOptionsProps {
    shortcutGroupToShortcuts: ShortcutGroupToShortcuts;
    onShortcutGroupAction: (action: ShortcutGroupAction) => void;
}

export const MoreShortcutGroupOptions: React.FC<IMoreShortcutGroupOptionsProps> = ({
    shortcutGroupToShortcuts,
    onShortcutGroupAction,
}) => {
    const deleteShortcutGroupText = (): JSX.Element =>
        <Typography className="red-text">
            Delete shortcut group
        </Typography>;

    const atLeastOneEnabled = () => shortcutGroupToShortcuts.shortcuts.some(s => s.isEnabled);

    return <MoreOptionsIconButton>
        <List disablePadding>
            <MoreOptionsItem
                text="Add new shortcut"
                onClick={() => onShortcutGroupAction(ShortcutGroupAction.ADD_SHORTCUT)}
            />
            <Divider light />
            <MoreOptionsItem
                text="Rename"
                onClick={() => onShortcutGroupAction(ShortcutGroupAction.EDIT)}
            />
            <Divider light />
            <MoreOptionsItem
                text={atLeastOneEnabled() ? "Disable all" : "Enable all"}
                onClick={() => onShortcutGroupAction(atLeastOneEnabled() ? ShortcutGroupAction.DISABLE_ALL : ShortcutGroupAction.ENABLE_ALL)}
            />
            <MoreOptionsItem
                text={deleteShortcutGroupText()}
                onClick={() => onShortcutGroupAction(ShortcutGroupAction.DELETE)}
            />
        </List>
    </MoreOptionsIconButton>;
};